export default {
  name: 'ru',
  data: {
    modal: {
      cancel: 'Отмена',
      confirm: 'OK'
    },
    pagination: {
      prev: 'Предыдущую',
      next: 'Следующую'
    },
    select: {
      empty: 'Нет Данных... \\[ o_x ]/'
    },
    table: {
      empty: 'Нет Данных... \\[ o_x ]/'
    }
  }
}